<template>
  <div class="page_row">
    <div
      class="signin-column benefits d-flex flex-column flex-fill justify-content-center align-items-center"
    >
      <p class="font-40 sign-in-now"
      :style="loginFontColor">Sign in now to</p>
      <div class="benefits_container">
        <div class="benefits__sign-up-item py-4">
          <img src="../module_user/assets/images/track.svg" alt srcset /><span
            class="font-16"
            :style="loginFontColor"
            >Set up personal goals and track daily progress</span
          >
        </div>
        <div class="benefits__sign-up-item py-4">
          <img
            src="../module_user/assets/images/newcontent.svg"
            alt
            srcset
          /><span class="font-16"
          :style="loginFontColor"
            >Get access to exclusive workout videos</span
          >
        </div>
        <div class="benefits__sign-up-item py-4">
          <img src="../module_user/assets/images/share.svg" alt srcset /><span
            class="font-16"
            :style="loginFontColor"
            >Share your achievements on social media</span
          >
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div
      class="signin-column reset d-flex flex-column flex-fill justify-content-center align-items-center"
    >
      <loader v-if="loggingIn" />
      <p class="font-30"
      :style="loginFontColor">Please enter new credentials</p>
      <b-form-group class="signin__input" :class = "{error:isPasswordError}">
        <password-input v-model="password" placeholder="Password"></password-input>
      </b-form-group>
      <b-form-group class="signin__input" :class = "{error:isConfirmPasswordError}">
        <password-input v-model="confirmPass" placeholder="Confirm Password"></password-input>  
      </b-form-group>
      <div class="custom-button custom-button__signin" 
      @click="resetPassword">
        <p>RESET PASSWORD</p>
      </div>
      <div class="sign_in__alert">
        <b-alert
          show
          variant="light"
          class="mt-3 p-1 font-green-16"
          v-if="resetError"
        >
          {{ resetError }}
        </b-alert>
        <password-checker
          :password="password"
          :cofirmPassword="confirmPass"
          ref="passwordChecker"
          class="mt-2"
          :hide="resetError"
        ></password-checker>
        <b-alert
          show
          variant="success"
          class="mt-2 p-1 font-green-16"
          v-if="passwordResetSuccessful"
        >
          Password Reset Successfully. Please login.
        </b-alert>

        <div class="mt-3 text-center mb-2 font-16"
        :style="loginFontColor">
          *Password should contain at least one uppercase, one special character
          and one numeric character, should be at least 8 characters long, should
          not contain whitespaces.
        </div>
      </div>
      <span class="sign-in mt-3 font-16"
      :style="loginFontColor"
        >Back to
        <span @click="signIn" class="font-green-16 cursor-ptr"
          >Sign In</span
        ></span
      >
       <div class="acc-create-divider mb-4"></div>
      <div class="signin__sign-up-with">
        <span class="font-16 mr-3"
        :style="loginFontColor"> SIGN UP WITH</span>
        <span
          class="custom-button custom-button__signin sign-in-icon custom-button-greyed fb-btn"
           >
          <p><img src="../module_user/assets/images/fb.svg" alt srcset /></p>
        </span>
          <google-sso
            class="custom-button custom-button__signin sign-in-icon google-btn"
          >
            <img src="../module_user/assets/images/google.svg" alt srcset />
          </google-sso>
        <span
          @click="signUpMail"
          class="custom-button custom-button__signin sign-in-icon env-btn"
        >
          <p>
            <img class="envelope" src="../module_user/assets/images/envelope.svg" alt srcset />
          </p>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { MESSAGES } from "@/module_user/uitls/messages";
import { mapMutations, mapState } from "vuex";
import { notify } from "@/module_user/uitls/notification-helper";
import PasswordChecker from "@/components/PasswordChecker";
import GoogleSso from "@/components/GoogleSso";
import PasswordInput from "@/components/PasswordInput";

export default {
  props: ["email", "token"],
  data: function () {
    return {
      confirmPass: "",
      password: "",
      isPasswordError: false,
      isPasswordErrorMessage : "",
      isConfirmPasswordError: false,
      isConfirmPasswordErrorMessage: "",
      loginFontColor: 'color: #73BC44',
    };
  },
  computed: {
    ...mapState(["resetError", "loggingIn", "passwordResetSuccessful"]),
    passwordMatch() {
      return (
        this.password && this.confirmPass && this.password == this.confirmPass
      );
    },
    validPassword() {
      return this.$refs.passwordChecker.isValid;
    },
  },
  methods: {
    ...mapMutations(["setResetError", "setCloseOnHeader"]),

    signIn() {
      this.$router.push("/ef/sign-in");
    },

    signUpMail() {
      this.$router.push("/ef/sign-up");
    },

    async resetPassword() {
      this.setResetError(null);
      if (!this.password || !this.confirmPass) {
        if(this.password == null || this.password == ""){
         this.isPasswordError = true;
        }
        if(this.confirmPass == null || this.confirmPass == ""){
          this.isConfirmPasswordError = true;
        }
        this.setResetError(MESSAGES.ENTER_CREDENTIALS);
        return;
      }
      if (this.password !== this.confirmPass) {
        this.isPasswordError = true;
        this.isConfirmPasswordError = true;
        return;
      }
      if (!this.validPassword) {
        this.isConfirmPasswordError = true;
        this.setResetError(MESSAGES.ENTER_COMPLEX_PASSWORD);
        return;
      }
      await this.$store.dispatch("resetPassword", {
        password: this.password,
        email: this.email,
        token: this.token,
      });
    },
  },
  mounted() {
    this.setCloseOnHeader(false);
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.email || !to.query.token) {
      next("/ef/sign-in");
    } else {
      next();
    }
  },
  beforeRouteLeave(to, from, next) {
    this.setResetError(null);
    next();
  },
  components: {
    PasswordChecker,
    GoogleSso,
    PasswordInput
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/style/_custom.scss";
.signin__input {
  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: $primary-color;
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: $primary-color;
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: $primary-color;
  }
}
input, input:focus{
  color: $primary-color;
}
.custom-button__signin{
  color: $primary-color;
}
.custom-button__signin:hover{
  color:white;
}
.page_row{
  background-image: url('~@/assets/signinbg.png');
  min-height: 90vh;
  color: #FFFFFF;
}
.error{
  box-shadow: 0 0 5px red;
}
.error input:focus{
   box-shadow: 0 0 0px red;
 }
.reset {
  padding: 6% 16% 4% 0%;
}
.divider {
  width: 1px;
  height: 70%;
  background-color: #c1c1c1;
  position: absolute;
  top: 50%;
  transform: translate(0%,-50%);
  left: 0;
  right: 0;
  margin: auto;
}
.acc-create-divider {
  margin-top: 5%;
  height: 1px;
  background-color: #c1c1c1;
  width: 70%;
}
.envelope{
  width:19px !important;
}
.fb-btn{
  width: 50px !important; 
  background: grey; 
  margin: 0 10px
}
.google-btn{
  width: 50px !important; 
  background: $primary-color;
  margin: 0 10px
}
.env-btn{
  width: 50px !important; 
  background: $primary-color;
  margin: 0 10px
}
@media only screen and (max-device-width: 736px) and (orientation: portrait){
  .page_row{
    display:flex;
    flex-direction: column;
    background-position: center;
    background-size: cover;
    height: fit-content;
  }
  .benefits{
    width:100%;
  }
  .signin-column{
    width:100%;
  }
  .divider{
    display: none;
  }
   .sign-in-now{
    font-size: 25px !important;
  }
}
@media only screen and (min-device-width: 500px) and (max-device-width: 670px) and (orientation: landscape){
  .page_row{
    padding: 8% 3% 0 3%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    height: auto !important;
  }
.acc-create-divider {
  position: absolute;
  width:35%;
  top:114% !important;
}
.signin__sign-up-with{
  margin-top: 13% !important;
  width:95%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4%;
}
.signin-column{
    margin: 0;
    padding: 0 !important;
    float:none;
    justify-content: unset !important;
}
.divider{
  top: 72%;
  height: 123vh;
}
.fb-btn{
  width: 40px !important; 
  background: grey; 
  margin: 0 5px
}
.google-btn{
  width: 40px !important; 
  background: $primary-color;
  margin: 0 5px
}
.env-btn{
  width: 40px !important; 
  background: $primary-color;
  margin: 0 5px
}
}
@media only screen and (min-device-width: 700px)and (max-device-width: 770px) and (orientation: landscape){
.page_row{
    padding: 8% 3% 0 3%;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    height: auto !important;
  }
.acc-create-divider {
  top:103% !important;
  position: absolute;
  width:35%;
}.signin__sign-up-with{
  margin-top: 13% !important;
  width:95%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4%;
}
.signin-column{
    margin: 0;
    padding: 0 !important;
    float:none;
    justify-content: unset !important;
}
.divider{
  top: 65%;
  height: 106vh;
}
.fb-btn{
  width: 40px !important; 
  background: grey; 
  margin: 0 5px
}
.google-btn{
  width: 40px !important; 
  background: $primary-color;
  margin: 0 5px
}
.env-btn{
  width: 40px !important; 
  background: $primary-color;
  margin: 0 5px
}
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait){
   .page_row{
    display:flex;
    flex-direction: column;
    background-position: center;
    background-size: cover;
    height: 100% !important;
    
  }
  .benefits{
    width:100%;
    padding: 5% 5% 0% 10% !important;
  }
  .signin-column{
    width: 100%;
    justify-content: unset !important;
    flex:unset !important;
    height: auto;
    margin-top: 10% !important;
  }
  .signin{
    justify-content: unset !important;
  }
  .divider{
    display: none;
  }
  .benefits_container{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .benefits__sign-up-item{
    text-align: left;
    width: 85% !important;
    display: flex;
    margin: 0 !important
  }
  .benefits__sign-up-item span{
    font-size: 20px;
  }
  .sign-in-now{
    font-size: 40px !important;
  }
}
@media only screen 
  and (min-device-width: 768px) 
  and (max-device-width: 1024px) 
  and (orientation: landscape)  {
  .benefits{
    padding:0 !important
  }
  .reset{
    padding: 0!important;
  }
}
</style>